// English (Canada) dictionary
export const enCA = {
  app: {
    title: "FBO Micro UI App",
    theme: {
      light: "Light",
      dark: "Dark",
      system: "System",
      toggle: "Toggle theme",
    },
    settings: {
      open: "Open settings",
      title: "Application Settings",
      tabs: {
        auth: "Authentication",
        features: "Features",
        codes: "Code Values",
        debug: "Debug",
      },
    },
    api: {
      title: "API Configuration",
      url: "API URL:",
      environment: "Environment:",
      adminServiceApiEndpoint: "Admin Service API:",
    },
    auth: {
      title: "Authentication Status",
      status: "Status:",
      authenticated: "Authenticated",
      unauthenticated: "Unauthenticated",
      token: "Token:",
      source: "Source:",
      sourceUrl: "URL Parameter",
      sourceDefault: "Default Token",
      sourceCustom: "Custom Token",
      sourceParent: "Parent Window",
      sourceNone: "None",
      noTokenMessage:
        "No authentication token found. The application expects to receive a token from the opener window.",
      clearCustomToken: "Clear custom token",
      confirmClearToken: "Are you sure you want to clear your custom token?",
      customToken: {
        title: "Custom Authentication Token",
        description: "Enter a custom token to use instead of the default token",
        placeholder: "Enter your JWT token here",
        save: "Save Token",
        paste: "Paste",
        success: "Token saved successfully!",
        error: "Please enter a valid token",
      },
    },
    apiExample: {
      title: "API Example",
      loading: "Loading...",
      callMainApi: "Call Main API",
      callAdminApi: "Call Admin API",
    },
    language: {
      switch: "Switch language",
      english: "English (Canada)",
      french: "Français (Canada)",
      current: "Current Language:",
      source: "Language Source:",
      sourceUrl: "URL Parameter",
      sourceCookie: "Cookie",
      sourceDefault: "Default",
    },
  },
  counter: {
    decrease: "Decrease",
    increase: "Increase",
  },
  featureFlags: {
    title: "Feature Flags",
    enabled: "Enabled",
    disabled: "Disabled",
    noFlags: "No feature flags available",
    mockData: "Mock Data",
    mockDataTitle: "Using Mock Data",
    mockDataDescription: "Feature flags are currently loaded from mock data due to CORS restrictions.",
    showFlags: "Show Feature Flags",
    hideFlags: "Hide Feature Flags",
    errors: {
      title: "Error",
      loadFailed: "Failed to load feature flags. Please try again later.",
      notAuthenticated: "Authentication required to load feature flags",
    },
  },
  codeValues: {
    title: "Code Values",
    noValues: "No code values available",
    showValues: "Show Code Values",
    hideValues: "Hide Code Values",
    errors: {
      title: "Error",
      loadFailed: "Failed to load code values. Please try again later.",
      notAuthenticated: "Authentication required to load code values",
    },
  },
}

// French (Canada) dictionary
export const frCA = {
  app: {
    title: "Application Micro UI FBO",
    theme: {
      light: "Clair",
      dark: "Sombre",
      system: "Système",
      toggle: "Changer le thème",
    },
    settings: {
      open: "Ouvrir les paramètres",
      title: "Paramètres de l'Application",
      tabs: {
        auth: "Authentification",
        features: "Fonctionnalités",
        codes: "Valeurs de Code",
        debug: "Débogage",
      },
    },
    api: {
      title: "Configuration de l'API",
      url: "URL de l'API :",
      environment: "Environnement :",
      adminServiceApiEndpoint: "API de Service Admin :",
    },
    auth: {
      title: "État d'Authentification",
      status: "Statut :",
      authenticated: "Authentifié",
      unauthenticated: "Non Authentifié",
      token: "Jeton :",
      source: "Source :",
      sourceUrl: "Paramètre d'URL",
      sourceDefault: "Jeton par Défaut",
      sourceCustom: "Jeton Personnalisé",
      sourceParent: "Fenêtre Parent",
      sourceNone: "Aucune",
      noTokenMessage:
        "Aucun jeton d'authentification trouvé. L'application attend de recevoir un jeton de la fenêtre d'ouverture.",
      clearCustomToken: "Effacer le jeton personnalisé",
      confirmClearToken: "Êtes-vous sûr de vouloir effacer votre jeton personnalisé ?",
      customToken: {
        title: "Jeton d'Authentification Personnalisé",
        description: "Entrez un jeton personnalisé à utiliser au lieu du jeton par défaut",
        placeholder: "Entrez votre jeton JWT ici",
        save: "Enregistrer le Jeton",
        paste: "Coller",
        success: "Jeton enregistré avec succès !",
        error: "Veuillez entrer un jeton valide",
      },
    },
    apiExample: {
      title: "Exemple d'API",
      loading: "Chargement...",
      callMainApi: "Appeler l'API Principale",
      callAdminApi: "Appeler l'API Admin",
    },
    language: {
      switch: "Changer de langue",
      english: "English (Canada)",
      french: "Français (Canada)",
      current: "Langue Actuelle :",
      source: "Source de la Langue :",
      sourceUrl: "Paramètre d'URL",
      sourceCookie: "Cookie",
      sourceDefault: "Par Défaut",
    },
  },
  counter: {
    decrease: "Diminuer",
    increase: "Augmenter",
  },
  featureFlags: {
    title: "Indicateurs de Fonctionnalités",
    enabled: "Activé",
    disabled: "Désactivé",
    noFlags: "Aucun indicateur de fonctionnalité disponible",
    mockData: "Données Simulées",
    mockDataTitle: "Utilisation de Données Simulées",
    mockDataDescription:
      "Les indicateurs de fonctionnalités sont actuellement chargés à partir de données simulées en raison des restrictions CORS.",
    showFlags: "Afficher les Indicateurs",
    hideFlags: "Masquer les Indicateurs",
    errors: {
      title: "Erreur",
      loadFailed: "Échec du chargement des indicateurs de fonctionnalités. Veuillez réessayer plus tard.",
      notAuthenticated: "Authentification requise pour charger les indicateurs de fonctionnalités",
    },
  },
  codeValues: {
    title: "Valeurs de Code",
    noValues: "Aucune valeur de code disponible",
    showValues: "Afficher les Valeurs de Code",
    hideValues: "Masquer les Valeurs de Code",
    errors: {
      title: "Erreur",
      loadFailed: "Échec du chargement des valeurs de code. Veuillez réessayer plus tard.",
      notAuthenticated: "Authentification requise pour charger les valeurs de code",
    },
  },
}

// Dictionary map
export const dictionaries = {
  "en-CA": enCA,
  "fr-CA": frCA,
}

export type Locale = keyof typeof dictionaries
